import { CONSTANTS } from "../../data";
import type { GameState } from "../../types";

/**
 * Handles all brewing-related state changes including:
 * - Adding/removing items from brew stations
 * - Managing brew station positions on the grid
 * - Temperature control updates
 * - Environmental state changes
 * - Quality grade tracking
 */
export const brewingReducer = (state: GameState, action: any): GameState => {
  switch (action.type) {
    case "ADD_TO_STATION": {
      const { stationIndex, slotIndex, item } = action;
      const newStations = [...state.brewStations];
      newStations[stationIndex].slots[slotIndex] = item;
      return { ...state, brewStations: newStations };
    }

    case "REMOVE_FROM_STATION": {
      const removeStations = [...state.brewStations];
      removeStations[action.stationIndex].slots[action.slotIndex] = null;
      return { ...state, brewStations: removeStations };
    }

    case "SET_BREW_QUANTITY": {
      const { stationIndex, quantity } = action;
      const newStations = state.brewStations.map((station, index) => {
        if (index === stationIndex) {
          return { ...station, quantity };
        }
        return station;
      });
      return { ...state, brewStations: newStations };
    }

    case "UPDATE_BREW_STATION_GRID_POSITION": {
      const { stationIndex, gridPosition } = action;
      const newStations = state.brewStations.map((station, index) => {
        if (index === stationIndex) {
          return { ...station, gridPosition };
        }
        return station;
      });
      return { ...state, brewStations: newStations };
    }

    case "ADD_BREW_STATION":
      return {
        ...state,
        brewStations: [...state.brewStations, { slots: [null, null], quantity: 1, gridPosition: { tileX: -1, tileY: -1 } }],
      };

    case "SET_TEMPERATURE": {
      // Update challenge progress for temperature-related challenges
      let tempUpdatedChallenge = state.masterChefChallenge;
      if (state.masterChefChallenge.active) {
        const challenge = CONSTANTS.MASTER_CHEF_CHALLENGES[state.masterChefChallenge.id];
        if (challenge && challenge.trackingKey === 'perfectTempHit' && action.perfectHit) {
          tempUpdatedChallenge = {
            ...state.masterChefChallenge,
            progress: state.masterChefChallenge.progress + 1
          };
        }
      }
      
      return {
        ...state,
        temperatureControl: {
          ...state.temperatureControl,
          currentTemp: action.temperature,
        },
        masterChefChallenge: tempUpdatedChallenge,
      };
    }

    case "UPDATE_ENVIRONMENTAL_STATE":
      return {
        ...state,
        environmentalState: {
          ...state.environmentalState,
          ...action.updates,
        },
      };

    case "SET_QUALITY_GRADE":
      return { ...state, lastQualityGrade: action.grade };

    default:
      return state;
  }
};
